import React,
{
    useState
}
from "react";

import asset1
    from "../../../../../images/demo/assetphotos/asset1.jpg";

import asset2
    from "../../../../../images/demo/assetphotos/asset2.jpg";

import asset3
    from "../../../../../images/demo/assetphotos/asset3.jpg";

import asset4
    from "../../../../../images/demo/assetphotos/asset4.jpg";

import asset5
    from "../../../../../images/demo/assetphotos/asset5.jpg";

import asset6
    from "../../../../../images/demo/assetphotos/asset6.jpg";

export default function BuildingBookAssetPhotos()
{
    const [selectedPhoto,
        setSelectedPhoto] =
            useState(null);

    const photos =
    [
        {
            image: asset1,
            title: "Front Elevation"
        },

        {
            image: asset2,
            title: "Filter Section"
        },

        {
            image: asset3,
            title: "Control Panel"
        },

        {
            image: asset4,
            title: "Fan Assembly"
        },

        {
            image: asset5,
            title: "Data Plate"
        },

        {
            image: asset6,
            title: "Plant Room Overview"
        }
    ];

    return (

        <div>

            <button style={button}>
                Upload Photo
            </button>

            <div style={photoGrid}>

                {
                    photos.map(
                        function(photoItem, index)
                        {
                            return (

                                <div
                                    key={index}
                                    style={photoCard}
                                    onClick={
                                        function()
                                        {
                                            setSelectedPhoto(
                                                photoItem
                                            );
                                        }
                                    }
									onMouseEnter={
									    function(event)
									    {
									        event.currentTarget.style.transform =
									            "scale(1.03)";
									    }
									}

									onMouseLeave={
									    function(event)
									    {
									        event.currentTarget.style.transform =
									            "scale(1)";
									    }
									}
                                >

                                    <img
                                        src={photoItem.image}
                                        alt={photoItem.title}
                                        style={photo}
                                    />

                                    <div style={overlay}>

                                        <div style={photoTitle}>
                                            {photoItem.title}
                                        </div>

                                        <div style={photoDate}>
                                            15 Jun 2026
                                        </div>

                                    </div>

                                </div>

                            );
                        }
                    )
                }

            </div>

            {
                selectedPhoto &&

                <div
                    style={modalBackdrop}
                    onClick={
                        function()
                        {
                            setSelectedPhoto(null);
                        }
                    }
                >

                    <div
                        style={modal}
                        onClick={
                            function(event)
                            {
                                event.stopPropagation();
                            }
                        }
                    >

                        <img
                            src={selectedPhoto.image}
                            alt={selectedPhoto.title}
                            style={largePhoto}
                        />

                        <div style={modalTitle}>
                            {selectedPhoto.title}
                        </div>

                    </div>

                </div>
            }

        </div>

    );
}

const button =
{
    height: "40px",

    padding: "0px 20px",

    border: "0px",

    borderRadius: "20px",

    background:
        "linear-gradient(180deg,#5a9bd6 0%,#417fb7 100%)",

    color: "#fff",

    fontWeight: "600",

    cursor: "pointer",

    marginBottom: "20px"
};

const photoGrid =
{
    display: "grid",

    gridTemplateColumns:
        "repeat(auto-fill,minmax(260px,1fr))",

    gap: "20px"
};

const photoCard =
{
    position: "relative",

    height: "220px",

    borderRadius: "12px",

    overflow: "hidden",

    cursor: "pointer",

    boxShadow:
        "0 8px 20px rgba(0,0,0,0.15)",

    transition:
        "transform 0.2s ease"
};

const photo =
{
    width: "100%",

    height: "100%",

    objectFit: "cover"
};

const overlay =
{
    position: "absolute",

    left: 0,

    right: 0,

    bottom: 0,

    padding: "12px",

    background:
        "linear-gradient(180deg,transparent 0%,rgba(0,0,0,0.85) 100%)",

    color: "#fff"
};

const photoTitle =
{
    fontWeight: "600",

    fontSize: "14px"
};

const photoDate =
{
    fontSize: "12px",

    opacity: "0.8",

    marginTop: "4px"
};

const modalBackdrop =
{
    position: "fixed",

    left: "0px",

    top: "0px",

    right: "0px",

    bottom: "0px",

    background:
        "rgba(0,0,0,0.85)",

    display: "flex",

    justifyContent: "center",

    alignItems: "center",

    zIndex: "100000"
};

const modal =
{
    background: "#ffffff",

    padding: "20px",

    borderRadius: "12px",

    maxWidth: "1000px",

    width: "90%",

    boxShadow:
        "0 20px 60px rgba(0,0,0,0.35)"
};

const largePhoto =
{
    width: "100%",

    maxHeight: "75vh",

    objectFit: "contain",

    borderRadius: "8px"
};

const modalTitle =
{
    marginTop: "15px",

    fontSize: "18px",

    fontWeight: "600",

    textAlign: "center"
};